export default __webpack_public_path__ + "static/media/zones_unlocked.d50491b4.riv";